module.exports = __webpack_public_path__ + "img/info-square.699fe1cb.svg";